import { useEffect } from "react";

import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as Sentry from "@sentry/react";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";

import errorPage404 from "../../../../assets/img/error-page-404.svg?url";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    Sentry.captureMessage("404 Not Found", {
      level: "error",
      tags: {
        path: location.pathname,
        referrer: document.referrer || undefined,
      },
      extra: {
        search: location.search,
        hash: location.hash,
      },
    });
  }, [location.pathname, location.search, location.hash]);

  return (
    <Wrapper>
      <img alt="" height="auto" src={errorPage404} width={250} />
      <Heading data-testid="not-found-title">
        <FormattedMessage id="error.heading.notFound" />
      </Heading>
      <Message>
        <FormattedMessage id="error.message.notFound" />
      </Message>
      <StyledButton
        color="primary"
        onClick={() => navigate(-1)}
        size="medium"
        variant="contained"
      >
        <FormattedMessage id="common.back" />
      </StyledButton>
    </Wrapper>
  );
};

const Wrapper = styled("div")(({ theme }) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(2),
}));

const Heading = styled("h1")({
  marginBottom: 10,
});

const Message = styled("p")(({ theme }) => ({
  color: theme.palette.cf.cfDarkerGrey,
  textAlign: "center",
}));

const StyledButton = styled(Button)({
  marginTop: 40,
});

export { NotFoundPage };
